const modal = document.getElementById("pet-contact-us-modal");
const contactButtons = document.querySelectorAll(
  "[data-action='contact-us-modal']",
);
contactButtons.forEach((button) => {
  button.addEventListener("click", () => {
    modal.showModal();
  });
});
